import axios, { AxiosResponse } from "axios"
import { HTTPResponseModel } from "../../../../../common/models/HTTPResponseModel"

const API_URL = process.env.REACT_APP_API_URL
export const GET_STATUS_DEVIS = `${API_URL}project/GetProjectStatus`
export const getDevisStatus = async (
    Guid:string,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
  ): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(
        GET_STATUS_DEVIS, {
        params:{
            Guid:Guid
        }
      }
    )
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getDevisStatus(Guid, onAccessLost, onToastOrMessage)
    } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
      ares?.data?.Status?.FailureReason === 'Session expired'
    ) {
      if (onAccessLost) {
        onAccessLost(ares?.data?.Status?.Message)
      }
    }
    return ares
  }